"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLazyMod = void 0;
var admin_1 = require("services/page/admin");
exports.isLazyMod = function (type) {
    return [admin_1.TModuleType.TMultiProductModuleType].includes(type);
};
